/* this file is transformed by vux-loader */
/* eslint-disable */
/* this file is transformed by vux-loader */

/* eslint-disable */

/**
 * Created by WJX on 2017/12/1.
 */
import Vue from 'vue';
import { getUsersData, klnPublicJump } from '@/api/ajax';
import IndexApi from '@/api/index';
import Config from '@/config/index';
import querystring from "vux/src/tools/querystring/index.js";
var Api = new IndexApi();
var wxUserId = Api.getUserId(); // 获取用户ID，此为永久缓存，
// if(process.env.NODE_ENV !== 'production'){
//   Api.setVuexStorage({
//     departmentName: '普外科',
//     userIntegral: 11,
//     wxAccount: 'vzb0066',
//     nickName: '🌻',
//     wxOpenId: 'o38v7w-w8jisv6-y98lmP_IjgHNA',
//     departmentId: 36,
//     sex: 1,
//     fullName: '医洋测试',
//     userDataStatus: 3,
//     hospitalName: '首都医科大学附属北京中医院',
//     cityId: 2,
//     provinceId: 1,
//     headPhoto:
//       'http://thirdwx.qlogo.cn/mmopen/vi_32/DYAIOgq83eqrGeOnbsV8SDzM8bQ3KvVgO4RgKEQ5yaWw45bpPWicqMah2Xaic4zEW9iaZibIQz3LWCmmIx9h1rSYfA/132',
//     dutyName: '主任医师',
//     districtId: 3,
//     phone: '13283379288',
//     hospitalId: 24851,
//     grade: '',
//     dutyId: null,
//     id: 514033,
//     identId: 1,
//     shenceId: '94d936e7-503a-4a73-b308-3dac526b4c10'
//   });
// }

export var userGuide = function userGuide(store, to, next) {
  var wxUserInfo = Api.getStorage('wxUserInfo');

  if (!wxUserId) {
    wxUserId = Api.getUserId();
  } // 健全store


  if (wxUserInfo && wxUserInfo.userDataStatus && !store.state.wxUserInfo.userDataStatus) {
    Api.setVuexStorage(wxUserInfo);
  }

  var registerUserNext = function registerUserNext(to, next) {
    if (to.name == 'register') {
      // 砍价活动 转跳处理
      if (to.query.shareUserId) {
        location.href = "/html/bargain/index.html#/friendhelp?shareId=".concat(to.query.shareUserId);
      } else {
        next({
          path: '/home'
        });
      }
    } else if (to.name == 'courseShare') {
      // 从分享进入的已注册用户
      next({
        name: 'courseDetail',
        params: {
          id: to.params.id
        },
        query: to.query
      });
    } else if (to.name == 'liveShare') {
      next({
        name: 'liveDetail',
        params: {
          id: to.params.id
        },
        query: to.query
      });
    } else {
      next();
    }
  };
  /*
   * 授权
   * */


  var toWxAuthThenCallBack = function toWxAuthThenCallBack(uri, to) {
    location.href = Config.wxAuth(uri, to);
  };
  /*
   * 获取用户信息
   * */


  var getUserInfoFunc = function getUserInfoFunc(store, to, next) {
    // 注册用户
    if (wxUserInfo && wxUserInfo.userDataStatus && wxUserInfo.id) {
      registerUserNext(to, next);
    } else {
      // kln 关联
      if (Api.isKln()) {
        var userInfo = _querystring.parse(navigator.userAgent.split('?')[1]);

        var sendData = {
          sign: userInfo.accessToken,
          phone: userInfo.userPhone,
          userId: 0
        };
        klnPublicJump(sendData).then(function (res) {
          if (res.data.status == 1) {
            Api.setVuexStorage(res.data.users);
            next();
          } else {
            Vue.$vux.toast.show({
              text: res.data.message,
              position: 'top',
              type: 'text',
              width: '5rem'
            });
          }
        }).catch(function (e) {});
      } else if (to.name == 'specialTopic' && Api.kernel != 'wx') {
        // APP中的一个页面
        next();
      } else {
        // 从分享进入部分页面不需要授权与用户信息
        if (!wxUserId && to.meta.newUserEntry && (to.query.shareFlag || /shareFlag/.test(location.href)) && /courseDetail|courseShare|liveDetail|liveShare|headlineDetail|universally/.test(location.href)) {
          console.log('从分享来的', to.name); // 从定向到 旧的分享落地页

          if (to.name == 'courseDetail') {
            var query = to.query;
            next({
              path: '/courseShare/' + to.params.id,
              query: query
            });
          } else if (to.name == 'liveDetail') {
            var _query = to.query;
            next({
              path: '/liveShare/' + to.params.id,
              query: _query
            });
          } else if (to.name == 'headlineDetail' || to.name == 'universally') {
            next();
          } else {
            next();
          }

          return false;
        } // 获取用户信息


        getUsersData().then(function (res) {
          var resp = res.data.data; // 有用户信息

          if (resp) {
            // 初始化神测
            Vue.prototype.$sa.login(resp); // 已注册

            if (resp.userDataStatus) {
              Api.setVuexStorage(resp);
              registerUserNext(to, next);
            } else {
              Api.setVuexStorage(resp); // 微信答题跳过来

              if (to.query.tmpDati && to.query.tmpDati == 'yishenghui_dati_tmp') {
                if (/doc\.jimijiayuan\.cn/.test(location.href)) {
                  sessionStorage.vueRouterBackPage = 'http://cdn.yxvzb.com/html/datiEntranceLczlk.html';
                } else {
                  sessionStorage.vueRouterBackPage = 'http://cdn.yxvzb.com/html/datiEntrance.html';
                }

                next({
                  name: 'register'
                });
              } // todo: 兼容之前错误分享链接拼接错误 ?isTemp=图文消息?shareFlag=true /shareFlag=true/.test(location.href)
              // todo: 已上层处理为准
              else if (to.meta.newUserEntry && (to.query.shareFlag || /shareFlag/.test(location.href)) && /courseDetail|courseShare|liveDetail|liveShare|headlineDetail|universally/.test(location.href)) {
                console.log('我是从分享来的'); // 从定向到 旧的分享落地页

                if (to.name == 'courseDetail') {
                  console.log('录播分享');
                  var _query2 = to.query;
                  next({
                    path: '/courseShare/' + to.params.id,
                    query: _query2
                  });
                } else if (to.name == 'liveDetail') {
                  console.log('直播分享');
                  var _query3 = to.query;
                  next({
                    path: '/liveShare/' + to.params.id,
                    query: _query3
                  });
                } else if (to.name == 'headlineDetail' || to.name == 'universally') {
                  next();
                } else {
                  console.log('其他');
                  next();
                }
              } // 进入页面标识  识别页面权限 没权限则去注册页面
              else if (to.meta.newUserEntry) {
                // 新用户需注册的页面  只缓存了当前页面并没有
                if (to.name == 'liveDetail') {
                  sessionStorage.vueRouterBackPage = "".concat(location.origin, "/html/newWechat.html#").concat(to.fullPath);
                } else {
                  sessionStorage.vueRouterBackPage = location.href;
                }

                console.log(sessionStorage.vueRouterBackPage);
                next({
                  name: 'register'
                });
              } else {
                next();
              }
            }
          } // 如果没有信息就去授权
          else {
            Vue.$vux.toast.show({
              text: '即将为您授权',
              position: 'top',
              type: 'text',
              width: '5rem'
            });
            toWxAuthThenCallBack(location.href, to);
          }
        }).catch(function (res) {
          // 授权
          // Vue.$vux.toast.show({
          //   text: '正在为您重载页面...',
          //   // position: 'top',
          //   type: 'cancel',
          //   width: '5rem',
          //   onHide() {
          //     location.reload()
          //   }
          // })
          Vue.$vux.toast.show({
            text: '即将为您授权',
            position: 'top',
            type: 'text',
            width: '5rem'
          });
          toWxAuthThenCallBack(location.href, to);
        });
      }
    }
  };

  getUserInfoFunc(store, to, next);
};